import {
  createFileRoute,
  redirect,
  stripSearchParams,
} from "@tanstack/react-router";
import { connectStripeAccount, getMyProfile } from "api-client";
import { z } from "zod";

import { loaderHandler } from "src/lib/loaderHandler";
import { CoachProductsPaymentSetupPage } from "src/pages/CoachProductsPaymentSetupPage";
import { productsFeeQueryOptions } from "src/queries/productsFee";

const routeSearchSchema = z.object({
  sync: z.boolean().default(false),
  refresh: z.boolean().default(false),
});

export const Route = createFileRoute(
  "/_auth/_coach/products/_tabs/payment-setup",
)({
  component: CoachProductsPaymentSetupPage,
  ssr: true,
  validateSearch: routeSearchSchema,
  search: {
    middlewares: [stripSearchParams({ sync: false, refresh: false })],
  },
  loaderDeps: ({ search }) => {
    return { refresh: search.refresh };
  },
  loader: async ({ deps, context }) => {
    return loaderHandler(async () => {
      const { profile } = (await getMyProfile()).data.data;
      const isProfilePublished = profile !== null && profile.isPublished;

      if (deps.refresh && isProfilePublished) {
        const response = await connectStripeAccount();
        throw redirect({ href: response.data.data.url });
      }

      await context.queryClient.query({
        ...productsFeeQueryOptions(),
        staleTime: "static",
      });

      return { data: { isProfilePublished } };
    });
  },
});
